/**
 * @method selectActionFactory
 * define new creator method for select
 */

import * as ajax from '../ajax';
import { constantsRegistry } from '../../constants/tableConstantsFactory';
/* eslint-disable-next-line import/no-cycle */
import tokenErrorActions from '../tokenErrorActionCreators';
/**
 * There are two batches of actions here.  The first operates on the local _only_
 * 'selected' list which reflects the items currently selected in an entity list.
 * The second is the 'selection' list which represents the entity data for the 'selected'
 * list which is returned after a server query.
 */
export default function selectActionFactory(entity, entityRoute) {
  const constants = constantsRegistry(entity);
  const select = id => ({
    type: constants.SELECT,
    id
  });

  // Dispatch action to select all entities passed in
  const selectAll = selected => ({
    type: constants.SELECT_ALL,
    selected
  });
  const selectClear = id => ({
    type: constants.SELECT_CLEAR,
    id
  });

  // Dispatch action to clear
  const selectClearAll = () => ({
    type: constants.SELECT_CLEAR_ALL
  });

  // Set loading in order to show spinner or not
  const selectIndex = loading => ({
    type: constants.SELECT_INDEX,
    loading // bool - true shows loading spiral on modal
  });
  const selectIndexClear = () => ({
    type: constants.SELECT_INDEX_CLEAR
  });
  const selectIndexFailure = err => ({
    type: constants.SELECT_INDEX_FAILURE,
    error: err
  });
  const selectIndexSuccess = data => ({
    type: constants.SELECT_INDEX_SUCCESS,
    data
  });
  /**
   * @param {Array} ids - Set of selected entites to query for
   */
  const serverIndexDetail = ids => async dispatch => {
    dispatch(selectIndex(true));
    try {
      const url = "/".concat(entityRoute, "/indexDetail");
      const response = await ajax.get(url, {
        ids
      });
      return dispatch(selectIndexSuccess(response.data));
    } catch (e) {
      return dispatch(tokenErrorActions.handleError(e, entity, selectIndexFailure.bind(this, e), serverIndexDetail.bind(this, ids)));
    }
  };
  return {
    select,
    selectAll,
    selectClear,
    selectClearAll,
    selectIndex,
    selectIndexClear,
    selectIndexFailure,
    selectIndexSuccess,
    serverIndexDetail
  };
}